// extracted by mini-css-extract-plugin
export var closeButton = "_k9-1";
export var closeX = "_k9-3";
export var container = "_k9-0";
export var image = "_k9-2";